import { safeNotificationHref } from './notificationUtils';

// Validate backend-supplied destinations before handing them to navigation.
// Notification resources intentionally support external HTTP(S) web links.
export const notificationNavigation = (value: string): string => {
  const safe = safeNotificationHref(value);
  if (!safe) return '#';
  try {
    const decoded = decodeURIComponent(safe);
    if (!safeNotificationHref(decoded)) return '#';
  } catch { return '#'; }
  return safe;
};

export const signatureNotificationPath = (type?: string | null, actionUrl?: string | null): string | null =>
  type?.toLowerCase().startsWith('signature ') &&
  /^\/signatures\?eventkey=(inbox|sent)&requestId=[0-9a-fA-F-]{36}$/.test(actionUrl || '')
    ? actionUrl!
    : null;
